import React, { useState } from "react";
import ChartView from "../../User/Report/ChartView";
import TableView from "../../User/Report/TableView";

const Report = () => {
  const [activeTab, setActiveTab] = useState("");

  const handleTabCliCk = (tabName) => {
    setActiveTab(tabName);
  };
  return (
    <div className="report-screen">
      {/* <Loading /> */}
      <div className="tab-header">
        <button
          className={`btn btn-tab ${activeTab === "" ? "active" : ""}`}
          onClick={() => handleTabCliCk("")}
        >
          Chart View
        </button>
        <div className="seperator"></div>
        <button
          className={`btn btn-tab ${activeTab === "table" ? "active" : ""}`}
          onClick={() => handleTabCliCk("table")}
        >
          Table View
        </button>
      </div>

      <div className="tab-body">
        {activeTab === "" && (
          <ChartView
            reportFlowAPI="dealer/report/flow/devices/betweenDates"
            reportLevelAPI="dealer/report/level/devices/betweenDates"
            viewDevicesAPI="view/devices/dealer"
          />
        )}
        {activeTab === "table" && (
          <TableView
            viewDeviceAPI="view/devices/dealer"
            flowReportDayAPI="dealer/flow/report/devices/betweenDates/group/day"
            levelReportDayAPI="dealer/level/report/devices/betweenDates/group/day"
            flowReportMonthAPI="dealer/flow/report/devices/betweenDates/group/month"
            levelReportMonthAPI="dealer/level/report/devices/betweenDates/group/month"
            flowReportHourAPI="dealer/flow/report/devices/betweenDates/group/hour"
            levelReportHourAPI="dealer/level/report/devices/betweenDates/group/hour"
            flowReportAPIwithoutFilter="dealer/report/flow/devices/betweenDates"
            levelReportAPIwithoutFilter="dealer/report/level/devices/betweenDates"
            workHourAPI="dealer/report/flow/workhour"
            flowBatteryReport="dealer/report/battery/flow"
            levelBatteryReport="dealer/report/battery/level"
          />
        )}
      </div>
    </div>
  );
};

export default Report;
